import React from 'react'

const SchemaOrthopaedics = () => {
    const schema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
            {
                "@type": "Question",
                "name": "What orthopedic services are available at HDNA Aarogyam Hospital?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "We provide comprehensive orthopedic care including joint replacement surgery (knee & hip), arthroscopy, sports injury treatment, fracture & trauma care, spine treatment, pediatric orthopedics, and rehabilitation services."
                }
            },
            {
                "@type": "Question",
                "name": "When should I consider knee or hip replacement surgery?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Joint replacement is recommended when chronic pain, stiffness, and reduced mobility due to arthritis or joint degeneration do not improve with medication, physiotherapy, or lifestyle changes."
                }
            },
            {
                "@type": "Question",
                "name": "What types of joint replacement surgeries are performed at HDNA Aarogyam Hospital?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "We offer Total Knee Replacement (TKR), Partial Knee Replacement, Total Hip Replacement (THR), and Revision Joint Replacement surgeries using advanced implant systems and minimally invasive techniques."
                }
            },
            {
                "@type": "Question",
                "name": "How long does recovery take after knee replacement surgery?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Most patients begin walking within a few days after surgery. Full recovery typically takes 6–12 weeks, depending on individual health, physiotherapy participation, and overall fitness."
                }
            },
            {
                "@type": "Question",
                "name": "Is joint replacement surgery safe?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, joint replacement is a safe and commonly performed procedure when done by experienced orthopedic surgeons. We follow strict safety protocols, advanced surgical planning, and post-operative monitoring to minimize risks."
                }
            },
            {
                "@type": "Question",
                "name": "Do you provide minimally invasive orthopedic surgeries?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, we use minimally invasive techniques whenever suitable. These procedures involve smaller incisions, reduced blood loss, less pain, and faster recovery."
                }
            },
            {
                "@type": "Question",
                "name": "What treatments are available for sports injuries?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "We provide arthroscopic surgery for ligament tears, meniscus injuries, shoulder instability, and other sports-related conditions, along with structured rehabilitation programs for faster return to activity."
                }
            },
            {
                "@type": "Question",
                "name": "Is emergency fracture and trauma care available?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, our orthopedic department offers 24/7 emergency trauma and fracture care with advanced imaging and surgical fixation facilities."
                }
            },
            {
                "@type": "Question",
                "name": "What rehabilitation services are available after surgery?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Our integrated physiotherapy and rehabilitation programs focus on mobility restoration, muscle strengthening, pain management, and faster recovery under expert supervision."
                }
            },
            {
                "@type": "Question",
                "name": "How can I book an appointment for orthopedic consultation in Patna?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "You can schedule a consultation by calling our hospital, visiting the facility in Patna, or booking an appointment online through our official website."
                }
            }
        ]
    };

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
    );
}

export default SchemaOrthopaedics
